import React from 'react';
import { UsersIcon, SearchIcon, FilterIcon, ShieldCheckIcon, DownloadIcon, MoreVerticalIcon } from 'lucide-react';
import { formatNaira } from '../../utils/format';
export function UserManagementModule({
  role
}: {
  role: string;
}) {
  const users = [{
    id: 'USR-1029',
    name: 'Adaeze Okonkwo',
    email: 'adaeze@example.com',
    phone: '+234 803 123 4567',
    tier: 3,
    balance: 2450000,
    status: 'Active',
    joined: '2025-11-10'
  }, {
    id: 'USR-1030',
    name: 'Chinedu Eze',
    email: 'chinedu@example.com',
    phone: '+234 805 987 6543',
    tier: 2,
    balance: 150000,
    status: 'Active',
    joined: '2026-01-15'
  }, {
    id: 'USR-1031',
    name: 'Ngozi Adeyemi',
    email: 'ngozi@example.com',
    phone: '+234 812 345 6789',
    tier: 1,
    balance: 0,
    status: 'Suspended',
    joined: '2026-02-28'
  }, {
    id: 'USR-1032',
    name: 'Emeka Nwosu',
    email: 'emeka@example.com',
    phone: '+234 701 234 5678',
    tier: 2,
    balance: 450000,
    status: 'Active',
    joined: '2026-03-01'
  }];
  return <div className="space-y-6" data-id="element-790">
      <div className="flex justify-between items-center" data-id="element-791">
        <div data-id="element-792">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-793">User Management</h2>
          <p className="text-sm text-gray-500" data-id="element-794">
            View user profiles, KYC status, and wallet balances.
          </p>
        </div>
        {role === 'Super Admin' && <button className="bg-white border border-gray-200 text-[#0D3B3B] px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-gray-50 transition-colors" data-id="element-795">
            <DownloadIcon className="w-4 h-4" data-id="element-796" /> Export Data
          </button>}
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden" data-id="element-797">
        <div className="p-4 border-b border-gray-100 flex gap-4" data-id="element-798">
          <div className="relative flex-1" data-id="element-799">
            <SearchIcon className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-800" />
            <input type="text" placeholder="Search by name, email, phone, or NIN..." className="w-full pl-10 pr-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#2BA89D]/20 focus:border-[#2BA89D]" data-id="element-801" />
          </div>
          <button className="px-4 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm font-bold text-gray-600 flex items-center gap-2 hover:bg-gray-100" data-id="element-802">
            <FilterIcon className="w-4 h-4" data-id="element-803" /> Filter
          </button>
        </div>

        <div className="overflow-x-auto" data-id="element-804">
          <table className="w-full text-left" data-id="element-805">
            <thead data-id="element-806">
              <tr className="bg-gray-50/50 text-xs uppercase tracking-wider text-gray-500 font-semibold" data-id="element-807">
                <th className="px-6 py-4" data-id="element-808">User</th>
                <th className="px-6 py-4" data-id="element-809">Contact</th>
                <th className="px-6 py-4" data-id="element-810">KYC Tier</th>
                <th className="px-6 py-4" data-id="element-811">Wallet Balance</th>
                <th className="px-6 py-4" data-id="element-812">Status</th>
                <th className="px-6 py-4" data-id="element-813"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-814">
              {users.map(user => <tr key={user.id} className="hover:bg-gray-50" data-id="element-815">
                  <td className="px-6 py-4" data-id="element-816">
                    <div className="flex items-center gap-3" data-id="element-817">
                      <div className="w-10 h-10 rounded-full bg-[#0D3B3B] text-white flex items-center justify-center font-bold text-sm" data-id="element-818">
                        {user.name.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div data-id="element-819">
                        <div className="text-sm font-bold text-[#0D3B3B]" data-id="element-820">
                          {user.name}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-821">
                          Joined {user.joined}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-822">
                    <div className="text-sm text-gray-700" data-id="element-823">{user.email}</div>
                    <div className="text-xs text-gray-500" data-id="element-824">{user.phone}</div>
                  </td>
                  <td className="px-6 py-4" data-id="element-825">
                    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-bold ${user.tier === 3 ? 'bg-emerald-100 text-emerald-700' : user.tier === 2 ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-826">
                      <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-827" /> Tier{' '}
                      {user.tier}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm font-bold text-[#0D3B3B]" data-id="element-828">
                    {formatNaira(user.balance)}
                  </td>
                  <td className="px-6 py-4" data-id="element-829">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold ${user.status === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`} data-id="element-830">
                      {user.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-831">
                    <button className="p-2 text-gray-400 hover:text-[#0D3B3B] rounded-lg hover:bg-gray-100" data-id="element-832">
                      <MoreVerticalIcon className="w-5 h-5" data-id="element-833" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}